<template lang="pug">
v-layout(v-show='expandDescription', column, align-start).mt-3.mb-4
    p.ma-0.mb-3.ml-2.description-text Add contact relationships to this contact, such as your Sibling, Partner, Lender, Escrow Rep, Appraiser, etc. You can quickly see their name, email and phone number!
    v-btn(small, color='primaryv2', @click='onOpenModal' :disabled="disableButton").white--text.add-btn Add Contact Relationships
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AddContactRelationships',
  props: {
    expandDescription: {
      type: Boolean,
      default: false,
    },
    disableButton: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    ...mapActions('contactRelationships', ['setShowModal']),
    onOpenModal() {
      this.setShowModal(true);
    },
  },
};
</script>

<style lang="scss" scoped>

.add-btn {
  width: 250px;
  font-size: 14px;
  align-self: center;
}

.description-text {
  width: 270px;
}

</style>
